import { ToastContainer } from 'react-toastify';
import { AuthProvider } from '@contexts/auth';
import { BrowserRouter } from "react-router";
import ChakraProvider from '@components/ChakraProvider'

import AppRoutes from './router';
import ErrorBoundary from './ErrorBoundary';

const App = () => (
  <ChakraProvider>
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <ToastContainer />
      </AuthProvider>
    </ErrorBoundary>
  </ChakraProvider>
);

export default App;
